import theme from '@app/ui/theme'
import styled from 'styled-components'

export const ViewToggleContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  margin-bottom: 16px;
  justify-content: flex-end;
`

export const ViewToggleButton = styled.button<{ active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border: 1px solid ${({ active }) => (active ? '#000' : '#ccc')};
  border-radius: 6px;
  background-color: ${({ active }) => (active ? '#000' : '#fff')};
  color: ${({ active }) => (active ? '#fff' : '#333')};
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s;
`

export const RatingHolesContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  width: 100%;
  @media (max-width: 820px) {
    grid-template-columns: 1fr;
  }
`

export const CompactRatingHolesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  width: 100%;
  @media (max-width: 820px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const CompactRatingHoleItem = styled.div<{ selected: boolean; filled: boolean }>`
  border-radius: 8px;
  border: 2px solid ${({ selected, filled }) =>
    selected ? theme.colors.secondary2 : filled ? theme.colors.primary2 : '#e0e0e0'};
  background: ${({ filled }) => (filled ? `${theme.colors.primary2}0d` : '#fafafa')};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 12px;
  transition: all 0.15s;
  opacity: ${({ filled }) => (filled ? 1 : 0.55)};
  gap: 2px;
  &:hover {
    border-color: ${theme.colors.secondary2};
    opacity: 1;
  }
`

export const CompactHoleNumber = styled.span<{ filled: boolean }>`
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
  color: ${({ filled }) => (filled ? theme.colors.primary2 : '#bbb')};
  margin-bottom: 4px;
`

export const CompactHolePar = styled.span`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
`

export const CompactHoleParValue = styled.span`
  font-weight: 700;
  color: rgba(0, 0, 0, 0.8);
`

export const CompactHoleMeta = styled.span`
  font-size: 11px;
  color: rgba(0, 0, 0, 0.45);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`

export const CompactHoleMetaValue = styled.span`
  font-weight: 600;
  color: rgba(0, 0, 0, 0.7);
`

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
`

export const StyledTable = styled.table`
  width: 99%;
  margin-top: 5px;
  border-collapse: collapse;
`

export const TableHead = styled.thead``

export const TableHeaderCell = styled.th`
  font-size: 13px;
  letter-spacing: 1px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.8);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 3px;
  text-align: left;
`

export const TableRow = styled.tr<{ selected: boolean; filled: boolean; separatorAfter?: boolean }>`
  cursor: pointer;
  &:last-child > * {
    border-bottom: none !important;
  }
  &:hover > td {
    background: #fafafa;
  }
  ${({ separatorAfter }) =>
    separatorAfter &&
    `
    & > td {
      border-bottom: 2px solid #000;
    }
  `}
`

export const TableCell = styled.td<{ filled?: boolean }>`
  font-size: 16px;
  color: ${({ filled }) => (filled ? 'rgba(0,0,0,0.8)' : 'rgba(0,0,0,0.3)')};
  font-weight: 600;
  text-align: left;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  min-height: 30px;
  padding: 5px;
  padding-left: 0;
`

export const TableStatusPill = styled.div<{ selected: boolean; filled: boolean }>`
  border: 1px solid ${({ selected, filled }) =>
    selected ? theme.colors.secondary2 : filled ? theme.colors.primary2 : '#ccc'};
  border-radius: 18px;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  color: ${({ selected, filled }) =>
    selected ? theme.colors.secondary2 : filled ? theme.colors.primary2 : 'rgba(0,0,0,0.3)'};
`
export const Header = styled.div`
  display: flex;
  padding: 8px 16px;
  justify-content: space-between;
  align-items: center;
`

export const RatingHole = styled.div<{ selected: boolean }>`
  cursor: pointer;
  height: 128px;
  border-radius: 12px;
  box-shadow: 0px 4px 13px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  outline: ${({ selected }) =>
    selected ? `3px solid ${theme.colors.secondary2}` : 'none'};
`


export const Title = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`

export const CheckContainer = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${theme.colors.secondary2};
  display: flex;
  justify-content: center;
  align-items: center;
`

export const HoleInfoText = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
`
